import React from "react";
import { settingsSections, upcomingSections } from "./settingsConfig";

function SettingsMenu({ activeTab, onChange }) {
  return (
    <div className="card border-0 shadow-sm">
      <div className="card-body p-0">
        <div className="px-3 py-3 border-bottom">
          <div className="fw-bold">Settings Menu</div>
          <small className="text-muted">System configuration</small>
        </div>

        <div className="p-2">
          {settingsSections.map((section) => {
            const isActive = activeTab === section.key;
            return (
              <button
                key={section.key}
                type="button"
                className={`btn w-100 text-start mb-1 d-flex align-items-center gap-2 ${isActive ? "text-white fw-semibold" : "btn-light"}`}
                style={isActive ? { background: "#125b2d", borderColor: "#125b2d" } : {}}
                onClick={() => onChange(section.key)}
                title={section.label}
              >
                <i className={`bi ${section.icon}`}></i>
                <span>{section.label}</span>
              </button>
            );
          })}
        </div>

        {upcomingSections.length > 0 && (
          <div className="px-3 py-3 border-top">
            <div className="text-uppercase text-muted fw-bold mb-2" style={{ fontSize: 11 }}>Coming Later</div>
            {upcomingSections.map((section) => (
              <div key={section} className="d-flex align-items-center gap-2 text-muted py-1" style={{ fontSize: 13 }}>
                <i className="bi bi-dot"></i><span>{section}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default SettingsMenu;
